import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PortalType } from '@shared';
import { PortalContextProvider } from '../providers';

/**
 * Portal Context Resolver.
 *
 * Extracts the portal type from the route path and sets it in the PortalContextProvider.
 * Should be attached to the root 'cases' and 'investigations' routes.
 *
 * @example
 * Route: /cases/admin/sla-management → Sets PortalType.Cases
 * Route: /investigations/dashboard → Sets PortalType.Investigations
 */
export const portalContextResolver: ResolveFn<PortalType> = (route) => {
  const portalContext = inject(PortalContextProvider);

  // Extract portal type from the route path
  // The first segment of the path will be 'cases' or 'investigations'
  const portalTypeSegment = route.url[0]?.path;

  const portalType =
    portalTypeSegment === 'investigations' ? PortalType.Investigations : PortalType.Cases;

  portalContext.setPortalType(portalType);

  return portalType;
};
